<template>
  <v-text-field v-bind="$attrs" hide-details
 :value="setectVale" :lable="lable"   @input="changeData($event)"/>
</template>

<script>
export default {
  name: "InputField",
  props: ["setectVale", "lable"],

  methods: {
    changeData(event) {
      this.$emit("changeInput", event);
    }
  }
};
</script>
